import React from 'react'
import { faCircleCheck } from '@fortawesome/free-regular-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import palette from 'src/designSystem/variables/palette'
import styled from 'styled-components/macro'
import { Dropdown } from 'react-bootstrap'
import { FlexColumn, FlexRow } from '../Flex'

export const DropdownContainer = styled.div<{
  $hasSelected: boolean
  $isDisabled?: boolean
}>`
  display: flex;
  flex-direction: column;
  justify-content: start;
  align-items: center;
  width: 100%;

  label {
    cursor: pointer;
  }

  .selected-value {
    color: ${({ $hasSelected, $isDisabled }) =>
      $hasSelected && !$isDisabled
        ? palette.neutral.black
        : palette.neutral[400]};
  }
  .dropdown-toggle[aria-expanded='true'] {
    .selected-value {
      color: ${palette.neutral.white};
    }
  }

  ${({ $isDisabled }) =>
    $isDisabled &&
    `
    .dropdown-toggle:disabled:hover {
      background-color: ${palette.neutral.white};
    }
  `}
`

export const SelectDropdownLabel = styled.span<{ $isbold?: boolean }>`
  font-size: 14px;
  ${({ $isbold }) => $isbold && `font-weight: 600 !important;`}
`

export const SelectDropDownSelectedContainer = styled(FlexRow)`
  justify-content: space-between;
  position: relative;
`

export const SelectDropDownSelected = styled.span.attrs({
  className: 'selected-value',
})`
  max-width: 100%;
  width: 100%;
  overflow: hidden;
  word-break: break-word;
  text-overflow: ellipsis;
  display: flex;
  justify-content: space-between;
  align-items: center;
`

export const SelectMenu = styled(Dropdown.Menu)`
  &.dropdown-menu.show {
    width: 100%;
    max-height: 400px;
    max-width: unset;
  }

  .form-check-input {
    margin-top: 0;
    flex-shrink: 0;
    width: 16px;
    min-width: 16px;
    height: 16px;
    min-height: 16px;
  }
`

export const SelectedIcon = (): JSX.Element => (
  <FontAwesomeIcon
    icon={faCircleCheck}
    size="4x"
    color={`${palette.neutral.white}`}
  />
)

export const MultiSelectIconsContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
`

export const MultiSelectContainer = styled(FlexRow)`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
`

export const MultiSelectLabel = styled.label`
  display: flex;
  flex-direction: column;
  width: 100%;
  font-size: 14px;
  text-align: left;
`

export const MultiSelectOption = styled(FlexColumn)<{
  isSelected: boolean
  isDisabled?: boolean
}>`
  height: 190px;
  padding: 3em;
  border-radius: 16px;
  border: 1px solid #ccc;
  background-color: ${({ isSelected, isDisabled }) =>
    isDisabled
      ? palette.neutral[200]
      : isSelected
      ? palette.neutral[500]
      : palette.neutral.white};
  color: ${({ isSelected, isDisabled }) =>
    isDisabled
      ? palette.neutral[400]
      : isSelected
      ? palette.neutral.white
      : 'initial'};
  cursor: ${({ isDisabled }) => (isDisabled ? 'not-allowed' : 'pointer')};

  :not(:last-child) {
    margin-right: 2em;
  }

  :hover {
    background-color: ${({ isSelected, isDisabled }) =>
      isDisabled
        ? palette.neutral[200]
        : isSelected
        ? palette.neutral[800]
        : palette.neutral[50]};
  }
`

export const IconOptionName = styled.div`
  position: relative;
  top: 1.25em;
  font-size: 1.2em;
  font-weight: bold;
  text-align: center;
`

export const RowLabel = styled.span<{ $isMultiSelect?: boolean }>`
  margin-left: ${({ $isMultiSelect }) => ($isMultiSelect ? '1em' : '0')};
`
